module.exports = __webpack_public_path__ + "static/smgif-9205f936d5969cefab414f2709b2705a.gif";